var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M422.359,247.16c-95.814-55.319-250.654-55.318-345.845,0.002 c-95.198,55.323-94.693,145.012,1.121,200.33c95.82,55.322,250.66,55.321,345.858-0.002 C518.684,392.171,518.179,302.482,422.359,247.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M57.216,383.764c-6.725-3.882-17.592-3.882-24.272,0c-6.681,3.883-6.646,10.177,0.079,14.06 c6.725,3.883,17.592,3.883,24.273,0C63.977,393.941,63.942,387.647,57.216,383.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M47.101,342.594l3.4,1.963c1.502,0.867,3.352,0.867,4.854,0l204.381-117.999 c1.291-0.745,1.295-2.608,0.007-3.359l-3.474-2.026c-1.505-0.878-3.366-0.882-4.875-0.01L47.1,339.231 C45.807,339.979,45.807,341.847,47.101,342.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M69.185,364.538l1.179,0.681c0.521,0.301,1.163,0.301,1.684,0l70.909-40.939 c0.448-0.259,0.449-0.905,0.003-1.165l-1.205-0.703c-0.522-0.305-1.168-0.306-1.691-0.003l-70.879,40.963 C68.736,363.631,68.736,364.279,69.185,364.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M429.956,359.899l-54.977-31.844c-3.073-1.78-6.864-1.783-9.939-0.006L314.914,357l-51.495-29.618 c-2.047-1.179-4.567-1.177-6.612,0.004l-89.676,51.796c-0.736,0.425-0.735,1.487,0.001,1.911l150.9,86.87 c2.047,1.179,4.567,1.177,6.612-0.004l89.676-51.796c0.736-0.425,0.735-1.487-0.001-1.911l-35.981-20.723l51.615-29.812 C431.422,362.869,431.424,360.749,429.956,359.899z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M466.993,386.859c-7.087-4.092-18.54-4.092-25.582,0c-7.041,4.092-7.004,10.726,0.083,14.818 c7.087,4.092,18.541,4.092,25.582,0C474.118,397.585,474.081,390.951,466.993,386.859z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M61.401,361.424l-16.281,0.475l-16.281-0.475c-0.701,10.995,1.445,22.2,4.405,27.673l0.012-0.002 c0.53,1.201,1.595,2.34,3.223,3.28c4.804,2.774,12.567,2.774,17.34,0c1.655-0.962,2.719-2.132,3.221-3.365 C59.976,383.508,62.099,372.365,61.401,361.424z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M56.595,354.755c6.379,3.683,6.413,9.654,0.075,13.337c-6.338,3.683-16.646,3.683-23.025,0 c-6.379-3.683-6.412-9.654-0.075-13.337C39.908,351.073,50.216,351.073,56.595,354.755z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M54.072,356.221c4.977,2.873,5.003,7.532,0.059,10.405c-4.944,2.873-12.987,2.874-17.964,0 c-4.977-2.873-5.003-7.531-0.058-10.405C41.053,353.348,49.096,353.348,54.072,356.221z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.072,356.221c4.977,2.873,5.003,7.532,0.059,10.405c-4.944,2.873-12.987,2.874-17.964,0 c-4.977-2.873-5.003-7.531-0.058-10.405C41.053,353.348,49.096,353.348,54.072,356.221z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M36.815,328.105c-2.648-3.292-5.723-6.241-8.151-9.699c-1.656-2.359-3.041-5.246-2.345-8.043 c0.646-2.595,3.071-4.525,5.7-5.017c2.629-0.492,5.381,0.294,7.651,1.707c2.271,1.413,4.116,3.413,5.783,5.504 c9.11,11.433,13.548,26.481,12.099,41.027c-0.166,1.667-0.445,3.422-1.511,4.715c-1.143,1.387-3.144,1.999-4.867,1.487 c-4.435-1.316-3.847-7.307-4.572-10.832c-0.994-4.83-2.719-9.51-5.094-13.832C40.152,332.654,38.582,330.301,36.815,328.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M36.815,328.105c-2.648-3.292-5.723-6.241-8.151-9.699 c-1.656-2.359-3.041-5.246-2.345-8.043c0.646-2.595,3.071-4.525,5.7-5.017c2.629-0.492,5.381,0.294,7.651,1.707 c2.271,1.413,4.116,3.413,5.783,5.504c9.11,11.433,13.548,26.481,12.099,41.027c-0.166,1.667-0.445,3.422-1.511,4.715 c-1.143,1.387-3.144,1.999-4.867,1.487c-4.435-1.316-3.847-7.307-4.572-10.832c-0.994-4.83-2.719-9.51-5.094-13.832 C40.152,332.654,38.582,330.301,36.815,328.105z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M51.451,355.322c-0.171-0.034-0.305-0.181-0.313-0.364c-0.311-7.12-2.625-31.421-19.372-45.209 c-0.166-0.136-0.189-0.381-0.053-0.546c0.136-0.165,0.38-0.189,0.546-0.053c16.995,13.992,19.34,38.574,19.655,45.775 c0.009,0.214-0.157,0.395-0.371,0.405C51.511,355.33,51.48,355.328,51.451,355.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M53.898,356.093c-0.507,2.794-2.907,6.253-5.438,7.541c-2.509,1.277-5.422,1.619-8.229,1.377 c-2.858-0.246-5.634-1.066-8.353-1.981c-1.343-0.452-2.836-1.062-2.978-2.725c-0.076-0.878,0.319-1.728,0.95-2.342 c0.265-0.258,0.556-0.509,0.867-0.746c0.632-0.483,0.335-1.487-0.458-1.542c-0.799-0.055-1.594-0.144-2.381-0.294 c-1.818-0.347-3.608-1.04-4.998-2.261c-1.045-0.917-1.836-2.112-2.308-3.419c-0.404-1.118-0.517-2.522,0.33-3.357 c0.486-0.479,1.184-0.661,1.851-0.805c0.595-0.129,1.192-0.238,1.791-0.331c0.795-0.124,0.927-1.209,0.184-1.519l-2.526-1.052 c-0.701-0.292-1.432-0.605-1.917-1.19c-0.773-0.933-0.718-2.29-0.486-3.479c0.309-1.581,0.855-3.106,1.227-4.674 c0.372-1.567,0.567-3.222,0.167-4.782c4.716-0.478,9.562-0.253,14.149,0.945c1.37,0.358,2.756,0.806,3.861,1.691 c1.575,1.26,1.985,3.152,1.818,5.201c-0.032,0.389,0.502,0.536,0.688,0.193l1.614-2.976c0.486-0.897,1.586-1.235,2.509-0.802 c1.393,0.654,2.636,1.701,3.691,2.903c1.138,1.297,1.718,3.004,1.579,4.724c-0.188,2.325-0.594,4.68-1.177,6.935 c-0.153,0.591,0.509,1.036,1.005,0.679l0.077-0.056c0.441-0.319,0.982-0.51,1.522-0.443c1.427,0.177,1.791,1.622,1.886,2.853 C54.55,352.138,54.235,354.238,53.898,356.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M53.898,356.093c-0.507,2.794-2.907,6.253-5.438,7.541c-2.509,1.277-5.422,1.619-8.229,1.377 c-2.858-0.246-5.634-1.066-8.353-1.981c-1.343-0.452-2.836-1.062-2.978-2.725c-0.076-0.878,0.319-1.728,0.95-2.342 c0.265-0.258,0.556-0.509,0.867-0.746c0.632-0.483,0.335-1.487-0.458-1.542c-0.799-0.055-1.594-0.144-2.381-0.294 c-1.818-0.347-3.608-1.04-4.998-2.261c-1.045-0.917-1.836-2.112-2.308-3.419c-0.404-1.118-0.517-2.522,0.33-3.357 c0.486-0.479,1.184-0.661,1.851-0.805c0.595-0.129,1.192-0.238,1.791-0.331c0.795-0.124,0.927-1.209,0.184-1.519l-2.526-1.052 c-0.701-0.292-1.432-0.605-1.917-1.19c-0.773-0.933-0.718-2.29-0.486-3.479c0.309-1.581,0.855-3.106,1.227-4.674 c0.372-1.567,0.567-3.222,0.167-4.782c4.716-0.478,9.562-0.253,14.149,0.945c1.37,0.358,2.756,0.806,3.861,1.691 c1.575,1.26,1.985,3.152,1.818,5.201c-0.032,0.389,0.502,0.536,0.688,0.193l1.614-2.976c0.486-0.897,1.586-1.235,2.509-0.802 c1.393,0.654,2.636,1.701,3.691,2.903c1.138,1.297,1.718,3.004,1.579,4.724c-0.188,2.325-0.594,4.68-1.177,6.935 c-0.153,0.591,0.509,1.036,1.005,0.679l0.077-0.056c0.441-0.319,0.982-0.51,1.522-0.443c1.427,0.177,1.791,1.622,1.886,2.853 C54.55,352.138,54.235,354.238,53.898,356.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M53.898,356.093c-0.507,2.794-2.907,6.253-5.438,7.541 c-2.509,1.277-5.422,1.619-8.229,1.377c-2.858-0.246-5.634-1.066-8.353-1.981c-1.343-0.452-2.836-1.062-2.978-2.725 c-0.076-0.878,0.319-1.728,0.95-2.342c0.265-0.258,0.556-0.509,0.867-0.746c0.632-0.483,0.335-1.487-0.458-1.542 c-0.799-0.055-1.594-0.144-2.381-0.294c-1.818-0.347-3.608-1.04-4.998-2.261c-1.045-0.917-1.836-2.112-2.308-3.419 c-0.404-1.118-0.517-2.522,0.33-3.357c0.486-0.479,1.184-0.661,1.851-0.805c0.595-0.129,1.192-0.238,1.791-0.331 c0.795-0.124,0.927-1.209,0.184-1.519l-2.526-1.052c-0.701-0.292-1.432-0.605-1.917-1.19c-0.773-0.933-0.718-2.29-0.486-3.479 c0.309-1.581,0.855-3.106,1.227-4.674c0.372-1.567,0.567-3.222,0.167-4.782c4.716-0.478,9.562-0.253,14.149,0.945 c1.37,0.358,2.756,0.806,3.861,1.691c1.575,1.26,1.985,3.152,1.818,5.201c-0.032,0.389,0.502,0.536,0.688,0.193l1.614-2.976 c0.486-0.897,1.586-1.235,2.509-0.802c1.393,0.654,2.636,1.701,3.691,2.903c1.138,1.297,1.718,3.004,1.579,4.724 c-0.188,2.325-0.594,4.68-1.177,6.935c-0.153,0.591,0.509,1.036,1.005,0.679l0.077-0.056c0.441-0.319,0.982-0.51,1.522-0.443 c1.427,0.177,1.791,1.622,1.886,2.853C54.55,352.138,54.235,354.238,53.898,356.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M46.395,363.245c-0.02-0.099-0.997-4.834-3.806-11.029c0-0.111-0.047-0.215-0.134-0.29 c-0.088-0.192-0.175-0.382-0.266-0.577c0.807-7.408,3.74-12.576,3.769-12.627c0.107-0.186,0.043-0.422-0.142-0.53 c-0.186-0.104-0.422-0.043-0.53,0.143c-0.029,0.05-2.728,4.803-3.716,11.738c-3.221-6.46-8.36-14.015-16.292-19.536 c-0.177-0.121-0.418-0.079-0.54,0.097c-0.122,0.176-0.079,0.418,0.097,0.54c8.182,5.694,13.346,13.588,16.483,20.138 c-6.393-3.113-13.185-1.882-13.487-1.825c-0.21,0.04-0.348,0.243-0.309,0.454c0.03,0.16,0.155,0.278,0.306,0.308 c0.047,0.009,0.097,0.01,0.147,0c0.074-0.014,7.479-1.36,13.881,2.219c2.787,6.132,3.757,10.827,3.776,10.925 c0.032,0.159,0.156,0.276,0.306,0.306c0.048,0.01,0.099,0.01,0.15,0C46.3,363.659,46.436,363.455,46.395,363.245z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M471.403,363.314l-17.159,0.5l-17.159-0.5c-0.739,11.588,1.523,23.397,4.643,29.166l0.012-0.002 c0.559,1.266,1.681,2.466,3.397,3.456c5.063,2.923,13.245,2.923,18.275,0c1.744-1.014,2.866-2.247,3.395-3.546 C469.901,386.589,472.139,374.845,471.403,363.314z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M466.337,356.286c6.723,3.882,6.759,10.174,0.08,14.056c-6.679,3.882-17.544,3.882-24.267,0 c-6.723-3.882-6.758-10.174-0.079-14.056C448.751,352.405,459.615,352.405,466.337,356.286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M463.679,357.831c5.245,3.028,5.273,7.938,0.062,10.966c-5.211,3.028-13.687,3.028-18.932,0 c-5.245-3.028-5.273-7.938-0.062-10.966C449.958,354.803,458.434,354.803,463.679,357.831z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.679,357.831c5.245,3.028,5.273,7.938,0.062,10.966c-5.211,3.028-13.687,3.028-18.932,0 c-5.245-3.028-5.273-7.938-0.062-10.966C449.958,354.803,458.434,354.803,463.679,357.831z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M482.456,290.092c-38.669,12.662-39.019,38.531-30.302,56.953 c2.198,3.729,8.852,5.732,14.643-17.18l-10.157,1.302l11.837-5.999l3.074-9.19l-9.869,0.733l12.527-5.269 C478.825,297.482,482.456,290.092,482.456,290.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M482.456,290.092c-38.669,12.662-39.019,38.531-30.302,56.953 c2.198,3.729,8.852,5.732,14.643-17.18l-10.157,1.302l11.837-5.999l3.074-9.19l-9.869,0.733l12.527-5.269 C478.825,297.482,482.456,290.092,482.456,290.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M482.456,290.092c-38.669,12.662-39.019,38.531-30.302,56.953 c2.198,3.729,8.852,5.732,14.643-17.18l-10.157,1.302l11.837-5.999l3.074-9.19l-9.869,0.733l12.527-5.269 C478.825,297.482,482.456,290.092,482.456,290.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M471.519,296.562c-20.392,15.477-22.233,33.221-16.472,51.746 C453.009,331.996,450.807,315.503,471.519,296.562z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M416.96,316.371c38.117,5.367,42.741,29.402,37.683,48.007 c-1.428,3.839-7.292,6.809-16.492-13.567l9.675-0.475l-12.02-3.621l-4.39-8.048l9.313-0.957l-12.542-2.826 C421.57,322.65,416.96,316.371,416.96,316.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M416.96,316.371c38.117,5.367,42.741,29.402,37.683,48.007 c-1.428,3.839-7.292,6.809-16.492-13.567l9.675-0.475l-12.02-3.621l-4.39-8.048l9.313-0.957l-12.542-2.826 C421.57,322.65,416.96,316.371,416.96,316.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M416.96,316.371c38.117,5.367,42.741,29.402,37.683,48.007c-1.428,3.839-7.292,6.809-16.492-13.567 l9.675-0.475l-12.02-3.621l-4.39-8.048l9.313-0.957l-12.542-2.826C421.57,322.65,416.96,316.371,416.96,316.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M428.221,320.579c21.563,11.026,26.226,27.245,23.938,45.455 C451.347,350.504,450.658,334.778,428.221,320.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M493.613,325.378c-34.956,0.572-41.814,21.717-39.337,39.052 c0.857,3.619,5.81,6.953,16.383-10.382l-8.668-1.511l11.239-1.918l4.858-6.762l-8.287-1.905l11.62-1.143 C488.755,330.521,493.613,325.378,493.613,325.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M482.992,327.91c-20.669,7.525-26.687,21.621-26.663,38.289 C458.799,352.293,461.18,338.197,482.992,327.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M493.613,325.378c-34.956,0.572-41.814,21.717-39.337,39.052 c0.857,3.619,5.81,6.953,16.383-10.382l-8.668-1.511l11.239-1.918l4.858-6.762l-8.287-1.905l11.62-1.143 C488.755,330.521,493.613,325.378,493.613,325.378z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Windows"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M51.305,306.459l-0.353-156.782c-0.013-4.449,3.117-9.876,6.995-12.115L252.83,25.334 c1.925-1.111,3.672-1.224,4.945-0.511l-7.338-4.252l0.001,0.006c-1.284-0.814-3.092-0.746-5.098,0.411L50.457,133.216 c-3.878,2.239-7.007,7.666-6.994,12.115l0.352,156.782c0.006,2.099,0.716,3.6,1.866,4.374l-0.001,0l0.008,0.005 c0.126,0.084,0.257,0.16,0.393,0.226l7.237,4.215C52.079,310.192,51.311,308.648,51.305,306.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M250.437,20.57l0.001,0.006c-1.284-0.814-3.092-0.746-5.098,0.411L50.457,133.216 c-2.155,1.245-4.077,3.475-5.359,5.973l7.497,4.334c1.282-2.494,3.201-4.719,5.353-5.961L252.83,25.334 c1.925-1.111,3.672-1.224,4.945-0.511L250.437,20.57z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M43.462,145.331l0.352,156.782c0.006,2.099,0.716,3.6,1.866,4.374l-0.001,0 l0.008,0.005c0.126,0.084,0.257,0.16,0.393,0.226l7.237,4.215c-1.238-0.741-2.006-2.285-2.012-4.474l-0.353-156.782 c-0.005-1.98,0.614-4.153,1.642-6.154l-7.497-4.334C44.073,141.186,43.456,143.355,43.462,145.331z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M50.973,158.766l0.332,147.693c0.006,2.189,0.774,3.733,2.012,4.474 c0.037,0.022,0.073,0.044,0.11,0.064c0.017,0.01,0.036,0.016,0.053,0.025c1.265,0.665,2.977,0.539,4.865-0.551l194.883-112.228 c3.872-2.235,7.007-7.666,6.994-12.115L259.89,38.189L50.973,158.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M50.973,158.766l0.332,147.693c0.006,2.189,0.774,3.733,2.012,4.474 c0.037,0.022,0.073,0.044,0.11,0.064c0.017,0.01,0.036,0.016,0.053,0.025c1.265,0.665,2.977,0.539,4.865-0.551l194.883-112.228 c3.872-2.235,7.007-7.666,6.994-12.115L259.89,38.189L50.973,158.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M259.87,29.346c-0.006-2.189-0.776-3.732-2.015-4.473c-0.012-0.007-0.022-0.016-0.034-0.023 c-0.015-0.009-0.031-0.018-0.047-0.027c-1.273-0.713-3.02-0.6-4.945,0.511L57.947,137.562 c-3.878,2.239-7.007,7.666-6.995,12.115l0.02,9.089L259.89,38.189L259.87,29.346z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.232,143.916c1.057-0.61,1.916-0.12,1.92,1.094c0.003,1.214-0.851,2.693-1.907,3.304 c-1.057,0.61-1.916,0.12-1.92-1.094C58.321,146.005,59.175,144.526,60.232,143.916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M65.458,140.898c1.057-0.61,1.916-0.12,1.92,1.094c0.003,1.214-0.851,2.694-1.907,3.304 c-1.057,0.61-1.917,0.12-1.92-1.094C63.548,142.988,64.401,141.508,65.458,140.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M70.685,137.881c1.057-0.61,1.916-0.12,1.92,1.094c0.003,1.214-0.851,2.694-1.907,3.304 c-1.057,0.61-1.916,0.12-1.92-1.094C68.774,139.97,69.628,138.491,70.685,137.881z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.232,143.916c1.057-0.61,1.916-0.12,1.92,1.094c0.003,1.214-0.851,2.693-1.907,3.304 c-1.057,0.61-1.916,0.12-1.92-1.094C58.321,146.005,59.175,144.526,60.232,143.916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M65.458,140.898c1.057-0.61,1.916-0.12,1.92,1.094c0.003,1.214-0.851,2.694-1.907,3.304 c-1.057,0.61-1.917,0.12-1.92-1.094C63.548,142.988,64.401,141.508,65.458,140.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M70.685,137.881c1.057-0.61,1.916-0.12,1.92,1.094c0.003,1.214-0.851,2.694-1.907,3.304 c-1.057,0.61-1.916,0.12-1.92-1.094C68.774,139.97,69.628,138.491,70.685,137.881z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "199.382,172.5 226.787,156.678 226.777,153.21 199.373,169.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "238.374,146.514 230.62,150.991 230.63,154.46 238.384,149.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "186.979,188.259 250.459,151.608 250.449,148.139 186.969,184.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "181.127,191.637 181.117,188.168 173.363,192.645 173.373,196.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "195.325,171.368 157.929,192.959 157.939,196.428 195.335,174.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "161.76,173.553 154.006,178.03 154.016,181.499 161.77,177.022  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "152.651,199.481 152.641,196.012 128.157,210.148 128.167,213.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "116.831,233.881 116.841,237.35 140.458,223.714 140.448,220.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "167.546,199.478 167.536,196.009 128.181,218.731 128.191,222.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "208.104,158.868 215.859,154.391 215.849,150.922 208.095,155.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "179.587,171.858 179.597,175.327 202.092,162.339 202.082,158.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "146.67,194.337 172.239,179.574 172.229,176.106 146.66,190.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "139.257,198.617 139.247,195.148 116.758,208.132 116.768,211.601  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "107.049,208.615 148.369,184.759 148.359,181.29 107.039,205.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "172.142,145.243 172.132,141.767 106.173,179.849 106.182,183.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "129.552,161.236 129.542,157.76 106.148,171.266 106.158,174.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "136.286,145.269 106.124,162.683 106.134,166.159 136.296,148.745  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "137.56,156.612 201.046,119.958 201.037,116.482 137.55,153.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "160.145,131.494 143.545,141.078 143.555,144.554 160.155,134.97  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "121.733,127.881 82.385,150.599 82.395,154.068 121.743,131.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "106.298,145.389 82.409,159.182 82.419,162.65 106.308,148.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "116.703,142.856 190.987,99.968 190.978,96.499 116.693,139.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "221.863,82.142 221.853,78.673 198.311,92.266 198.32,95.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "240.855,71.177 240.846,67.708 229.074,74.504 229.084,77.973  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "117.821,147.333 94.378,160.868 94.388,164.337 117.831,150.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "217.562,106.941 207.111,112.975 207.121,116.451 217.572,110.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "250.288,91.529 250.278,88.053 222.874,103.874 222.884,107.35  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "192.51,150.678 192.5,147.202 128.592,184.099 128.602,187.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "121.302,188.307 94.5,203.782 94.51,207.258 121.312,191.783  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "107.846,187.48 94.475,195.199 94.485,198.675 107.856,190.956  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "206.274,202.916 214.028,198.439 214.018,194.963 206.264,199.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "201.061,205.926 201.051,202.45 176.188,216.805 176.198,220.281  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "250.546,182.471 141.481,245.439 141.491,248.915 250.556,185.947  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "171,219.8 141.457,236.857 141.467,240.333 171.01,223.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "116.904,259.629 116.914,263.105 135.968,252.104 135.959,248.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "135.934,240.045 106.392,257.102 106.401,260.578 135.944,243.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "121.876,239.565 106.367,248.519 106.377,251.995 121.886,243.041  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "208.104,158.868 215.859,154.391 215.849,150.922 208.095,155.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "179.587,171.858 179.597,175.327 202.092,162.339 202.082,158.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "146.67,194.337 172.239,179.574 172.229,176.106 146.66,190.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "139.257,198.617 139.247,195.148 116.758,208.132 116.768,211.601  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "121.733,127.881 82.385,150.599 82.395,154.068 121.743,131.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "106.298,145.389 82.409,159.182 82.419,162.65 106.308,148.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "116.703,142.856 190.987,99.968 190.978,96.499 116.693,139.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "221.863,82.142 221.853,78.673 198.311,92.266 198.32,95.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "240.855,71.177 240.846,67.708 229.074,74.504 229.084,77.973  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "192.51,150.678 192.5,147.202 128.592,184.099 128.602,187.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "121.302,188.307 94.5,203.782 94.51,207.258 121.312,191.783  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "107.846,187.48 94.475,195.199 94.485,198.675 107.856,190.956  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "206.274,202.916 214.028,198.439 214.018,194.963 206.264,199.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "201.061,205.926 201.051,202.45 176.188,216.805 176.198,220.281  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "250.546,182.471 141.481,245.439 141.491,248.915 250.556,185.947  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "171,219.8 141.457,236.857 141.467,240.333 171.01,223.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "116.904,259.629 116.914,263.105 135.968,252.104 135.959,248.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "135.934,240.045 106.392,257.102 106.401,260.578 135.944,243.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "121.876,239.565 106.367,248.519 106.377,251.995 121.886,243.041  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "64.94,191.802 64.965,200.396 64.94,191.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "64.974,203.699 72.453,199.381 72.453,199.381 64.974,203.699 64.998,212.294  64.998,212.294  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.429,
    y: 213.431,
    transform: "matrix(0.866 -0.5 0.5 0.866 -97.5072 62.9701)",
    style: {
      fill: "#FFFFFF"
    },
    width: 8.636,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.552,
    y: 256.69,
    transform: "matrix(0.866 -0.5 0.5 0.866 -119.1185 68.8251)",
    style: {
      fill: "#FFFFFF"
    },
    width: 8.637,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.376,172.289 64.897,176.607 72.376,172.289  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "69.225,177.411 64.906,179.904 64.931,188.499 64.906,179.904  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.41,184.18 64.931,188.499 72.41,184.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.444,196.078 64.965,200.396 72.444,196.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "69.482,268.254 65.164,270.747 65.188,279.341 65.188,279.341 65.164,270.747  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.484,
    y: 232.901,
    transform: "matrix(0.866 -0.5 0.5 0.866 -107.235 65.6063)",
    style: {
      fill: "#FFFFFF"
    },
    width: 8.636,
    height: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.518,
    y: 244.799,
    transform: "matrix(0.866 -0.5 0.5 0.866 -113.1737 67.2115)",
    style: {
      fill: "#FFFFFF"
    },
    width: 8.637,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.42,187.484 64.94,191.802 64.965,200.396 72.444,196.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "64.998,212.294 72.478,207.975 72.453,199.381 64.974,203.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.576,242.64 65.096,246.958 65.121,255.553 72.6,251.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "65.155,267.444 72.634,263.126 72.61,254.531 65.13,258.849  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.542,230.742 65.063,235.061 65.087,243.655 72.566,239.337  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M74.943,226.585l-12.301,7.102l0.175,61.713l12.301-7.102L74.943,226.585z M72.61,254.531 l0.024,8.594l-7.479,4.318l-0.024-8.594v0L72.61,254.531L72.61,254.531z M65.063,235.061L65.063,235.061l7.479-4.318l0,0 l0.024,8.594l-7.479,4.318L65.063,235.061z M65.096,246.958L65.096,246.958l7.479-4.318v0l0.024,8.594l-7.479,4.318 L65.096,246.958z M65.188,279.341l-0.024-8.594l4.318-2.493l3.161-1.825l0.024,8.594L65.188,279.341L65.188,279.341 L65.188,279.341z M65.222,291.233l-0.024-8.595l7.479-4.318l0.024,8.595L65.222,291.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M74.753,159.531l-12.301,7.102l0.175,61.719l12.301-7.102L74.753,159.531z M64.873,168.013 l7.479-4.318l0.024,8.594h0l0,0l-7.479,4.318L64.873,168.013z M64.906,179.904l4.318-2.493l3.161-1.825l0.024,8.594l0,0l0,0 l-7.479,4.318L64.906,179.904z M64.94,191.802L64.94,191.802l7.479-4.318l0.024,8.594l0,0l-7.479,4.318L64.94,191.802z  M64.974,203.699l7.479-4.318v0l0.024,8.594l-7.479,4.318h0L64.974,203.699z M65.008,215.591L65.008,215.591L65.008,215.591 l7.479-4.318v0l0,0l0.024,8.594l-7.479,4.318L65.008,215.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M74.943,226.585l-12.301,7.102l0.175,61.713l12.301-7.102L74.943,226.585z  M72.61,254.531l0.024,8.594l-7.479,4.318l-0.024-8.594v0L72.61,254.531L72.61,254.531z M65.063,235.061L65.063,235.061 l7.479-4.318l0,0l0.024,8.594l-7.479,4.318L65.063,235.061z M65.096,246.958L65.096,246.958l7.479-4.318v0l0.024,8.594 l-7.479,4.318L65.096,246.958z M65.188,279.341l-0.024-8.594l4.318-2.493l3.161-1.825l0.024,8.594L65.188,279.341 L65.188,279.341L65.188,279.341z M65.222,291.233l-0.024-8.595l7.479-4.318l0.024,8.595L65.222,291.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M74.753,159.531l-12.301,7.102l0.175,61.719l12.301-7.102L74.753,159.531z  M64.873,168.013l7.479-4.318l0.024,8.594h0l0,0l-7.479,4.318L64.873,168.013z M64.906,179.904l4.318-2.493l3.161-1.825 l0.024,8.594l0,0l0,0l-7.479,4.318L64.906,179.904z M64.94,191.802L64.94,191.802l7.479-4.318l0.024,8.594l0,0l-7.479,4.318 L64.94,191.802z M64.974,203.699l7.479-4.318v0l0.024,8.594l-7.479,4.318h0L64.974,203.699z M65.008,215.591L65.008,215.591 L65.008,215.591l7.479-4.318v0l0,0l0.024,8.594l-7.479,4.318L65.008,215.591z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.41,184.18 72.386,175.586 69.225,177.411 64.906,179.904 64.931,188.499  72.41,184.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "74.753,159.531 74.739,154.738 62.438,161.84 62.451,166.633 74.753,159.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.377,172.289 72.352,163.694 64.873,168.013 64.897,176.607 72.376,172.289  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.487,211.272 72.487,211.272 65.008,215.591 65.008,215.591 65.032,224.185  72.511,219.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "72.668,275.023 72.643,266.429 69.482,268.254 65.164,270.747 65.188,279.341  65.188,279.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "65.198,282.638 65.222,291.233 72.701,286.915 72.677,278.32  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M220.864,104.078l-0.001-0.208l-0.009-3.113c-0.004-1.311,0.923-2.909,2.064-3.567l59.748-34.496 c0.594-0.343,1.126-0.358,1.503-0.114l0.001-0.005l2.02,1.457c0,0-1.317,0.825-1.317,0.855c0,0.007-0.056-0.005-0.134-0.023 l0.006,2.123l0.007,2.56l-61.918,35.748L220.864,104.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M220.864,104.078l-0.001-0.208l-0.009-3.113c-0.004-1.311,0.923-2.909,2.064-3.567 l59.748-34.496c0.594-0.343,1.126-0.358,1.503-0.114l0.001-0.005l2.02,1.457c0,0-1.317,0.825-1.317,0.855 c0,0.007-0.056-0.005-0.134-0.023l0.006,2.123l0.007,2.56l-61.918,35.748L220.864,104.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M222.836,105.296l61.918-35.748l0.12,42.476c0.004,1.311-0.917,2.905-2.057,3.563l-58.831,33.966 l0.538,0.669l-0.987,1.413l-2.01-1.451l0.007-0.006c-0.332-0.229-0.541-0.66-0.543-1.271l-0.127-44.828L222.836,105.296z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M224.891,98.616c-1.141,0.659-2.067,2.257-2.064,3.567l0.009,3.113l63.883-36.883L286.71,65.3 c-0.004-1.311-0.93-1.839-2.071-1.18L224.891,98.616z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.891,98.616c-1.141,0.659-2.067,2.257-2.064,3.567l0.009,3.113l63.883-36.883L286.71,65.3 c-0.004-1.311-0.93-1.839-2.071-1.18L224.891,98.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M222.836,105.296l0.128,45.037c0.004,1.311,0.937,1.835,2.077,1.176l59.748-34.496 c1.141-0.659,2.061-2.253,2.057-3.563l-0.128-45.037L222.836,105.296z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "265.744,117.782 265.75,119.662 283.484,109.423 283.478,107.543  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "265.711,106.143 265.716,108.024 283.451,97.785 283.445,95.904  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "271.025,94.949 271.03,96.83 283.428,89.672 283.422,87.792  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "248.97,131.533 248.975,133.406 271.792,120.233 271.787,118.359  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "243.263,126.681 243.268,128.561 271.769,112.106 271.764,110.226  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "257.586,98.071 257.591,99.952 271.712,91.799 271.706,89.919  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "236.944,118.685 236.95,120.566 271.736,100.482 271.731,98.601  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "226.12,133.061 226.125,134.941 271.759,108.594 271.754,106.714  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "226.062,112.747 226.067,114.627 271.702,88.281 271.696,86.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "265.654,85.829 265.659,87.71 283.393,77.471 283.388,75.591  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.744,117.782 265.75,119.662 283.484,109.423 283.478,107.543  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.711,106.143 265.716,108.024 283.451,97.785 283.445,95.904  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "271.025,94.949 271.03,96.83 283.428,89.672 283.422,87.792  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "248.97,131.533 248.975,133.406 271.792,120.233 271.787,118.359  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "243.263,126.681 243.268,128.561 271.769,112.106 271.764,110.226  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "257.586,98.071 257.591,99.952 271.712,91.799 271.706,89.919  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "236.944,118.685 236.95,120.566 271.736,100.482 271.731,98.601  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "226.12,133.061 226.125,134.941 271.759,108.594 271.754,106.714  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "226.062,112.747 226.067,114.627 271.702,88.281 271.696,86.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "265.654,85.829 265.659,87.71 283.393,77.471 283.388,75.591  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M67.85,290.64l-0.001-0.239l-0.01-3.573c-0.004-1.504,1.06-3.339,2.369-4.095l68.584-39.597 c0.681-0.393,1.292-0.411,1.726-0.132l0.001-0.006l2.319,1.673c0,0-1.512,0.946-1.512,0.981c0,0.007-0.064-0.006-0.154-0.027 l0.007,2.437l0.008,2.939l-71.075,41.035L67.85,290.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M67.85,290.64l-0.001-0.239l-0.01-3.573c-0.004-1.504,1.06-3.339,2.369-4.095 l68.584-39.597c0.681-0.393,1.292-0.411,1.726-0.132l0.001-0.006l2.319,1.673c0,0-1.512,0.946-1.512,0.981 c0,0.007-0.064-0.006-0.154-0.027l0.007,2.437l0.008,2.939l-71.075,41.035L67.85,290.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M70.113,292.038l71.075-41.035l0.138,48.758c0.004,1.504-1.053,3.335-2.362,4.091L71.434,342.84 l0.618,0.768l-1.133,1.621l-2.308-1.666l0.008-0.007c-0.382-0.263-0.622-0.758-0.624-1.459L67.85,290.64L70.113,292.038z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M72.471,284.37c-1.309,0.756-2.373,2.59-2.369,4.095l0.01,3.573l73.33-42.337l-0.01-3.573 c-0.004-1.504-1.068-2.111-2.377-1.355L72.471,284.37z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M72.471,284.37c-1.309,0.756-2.373,2.59-2.369,4.095l0.01,3.573l73.33-42.337l-0.01-3.573 c-0.004-1.504-1.068-2.111-2.377-1.355L72.471,284.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M70.113,292.038l0.147,51.697c0.004,1.504,1.075,2.106,2.384,1.35l68.584-39.597 c1.309-0.756,2.366-2.586,2.362-4.091l-0.146-51.697L70.113,292.038z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "73.92,333.003 73.926,335.161 94.283,323.408 94.277,321.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "73.882,319.643 73.888,321.801 94.245,310.048 94.239,307.89  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "73.882,310.458 73.888,312.617 88.119,304.401 88.113,302.242  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "88.162,329.04 88.168,331.191 114.359,316.069 114.353,313.919  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "88.227,319.785 88.233,321.943 120.949,303.055 120.943,300.896  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "87.03,297.131 87.036,299.289 103.245,289.931 103.238,287.773  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "88.253,305.873 88.259,308.032 128.19,284.978 128.184,282.819  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "88.227,315.91 88.233,318.068 140.615,287.825 140.609,285.667  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "86.964,293.267 86.97,295.426 139.353,265.182 139.346,263.024  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "73.816,296.325 73.822,298.483 94.179,286.73 94.173,284.572  "
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "73.92,333.003 73.926,335.161 94.283,323.408 94.277,321.25  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "73.882,319.643 73.888,321.801 94.245,310.048 94.239,307.89  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "73.882,310.458 73.888,312.617 88.119,304.401 88.113,302.242  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "88.162,329.04 88.168,331.191 114.359,316.069 114.353,313.919  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "88.227,319.785 88.233,321.943 120.949,303.055 120.943,300.896  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "87.03,297.131 87.036,299.289 103.245,289.931 103.238,287.773  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "88.253,305.873 88.259,308.032 128.19,284.978 128.184,282.819  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "88.227,315.91 88.233,318.068 140.615,287.825 140.609,285.667  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "86.964,293.267 86.97,295.426 139.353,265.182 139.346,263.024  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "73.816,296.325 73.822,298.483 94.179,286.73 94.173,284.572  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "401.51,257.14 401.51,244.642 345.747,224.945 289.984,244.642 289.984,257.351  346.112,289.757 401.875,257.351  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "401.51,257.14 401.51,244.642 345.747,224.945 289.984,244.642 289.984,257.351  346.112,289.757 401.875,257.351  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "408.434,227.691 345.726,191.486 283.425,227.691 346.133,263.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "408.434,227.691 345.726,191.486 283.425,227.691 346.133,263.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "346.133,263.896 346.071,285.731 408.373,249.525 408.434,227.691  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "346.133,263.896 346.071,285.731 408.373,249.525 408.434,227.691  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "283.425,227.691 283.363,249.526 346.071,285.731 346.133,263.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.694,236.086 287.665,246.307 317.022,263.257 317.051,253.035  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M290.82,241.406l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C291.578,242.238,291.237,241.647,290.82,241.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M294.24,243.381l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,244.212,294.657,243.622,294.24,243.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M297.66,245.355l-0.855-0.494c-0.424-0.245-0.761-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C298.419,246.187,298.078,245.596,297.66,245.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M301.081,247.33l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,248.162,301.498,247.571,301.081,247.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.501,249.305l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,250.137,304.918,249.546,304.501,249.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M307.922,251.28l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C308.68,252.111,308.339,251.521,307.922,251.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.342,253.254l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C312.1,254.086,311.759,253.495,311.342,253.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M294.24,243.381l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,244.212,294.657,243.622,294.24,243.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M301.081,247.33l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,248.162,301.498,247.571,301.081,247.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M304.501,249.305l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,250.137,304.918,249.546,304.501,249.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M311.342,253.254l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C312.1,254.086,311.759,253.495,311.342,253.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M314.762,255.229l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C315.52,256.061,315.18,255.47,314.762,255.229z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M339.601,271.493c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.754-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,272.725,339.599,272.21,339.601,271.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M339.601,271.493c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.754-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,272.725,339.599,272.21,339.601,271.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M336.854,274.197l0.015-0.008c-0.005,0.003-0.01,0.005-0.015,0.007L336.854,274.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M337.615,272.613c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,273.9,337.613,273.368,337.615,272.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M337.615,272.613c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,273.9,337.613,273.368,337.615,272.613z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M330.048,265.745c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,266.976,330.046,266.462,330.048,265.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M330.048,265.745c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,266.976,330.046,266.462,330.048,265.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M327.3,268.449l0.015-0.008c-0.005,0.003-0.01,0.004-0.015,0.007L327.3,268.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M328.061,266.865c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,268.152,328.059,267.62,328.061,266.865z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M328.061,266.865c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,268.152,328.059,267.62,328.061,266.865z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "401.51,226.661 401.51,214.163 345.747,194.466 289.984,214.163 289.984,226.872  346.112,259.278 401.875,226.872  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "401.51,226.661 401.51,214.163 345.747,194.466 289.984,214.163 289.984,226.872  346.112,259.278 401.875,226.872  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "408.434,197.212 345.726,161.007 283.425,197.212 346.133,233.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "408.434,197.212 345.726,161.007 283.425,197.212 346.133,233.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "346.133,233.417 346.071,255.252 408.373,219.046 408.434,197.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "346.133,233.417 346.071,255.252 408.373,219.046 408.434,197.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "283.425,197.212 283.363,219.047 346.071,255.252 346.133,233.417  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.694,205.607 287.665,215.829 317.022,232.778 317.051,222.556  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M290.82,210.927l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C291.578,211.759,291.237,211.168,290.82,210.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M294.24,212.902l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,213.734,294.657,213.143,294.24,212.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M297.66,214.877l-0.855-0.494c-0.424-0.245-0.761-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C298.419,215.708,298.078,215.118,297.66,214.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M301.081,216.852l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,217.683,301.498,217.092,301.081,216.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.501,218.826l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,219.658,304.918,219.067,304.501,218.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M307.922,220.801l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C308.68,221.633,308.339,221.042,307.922,220.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.342,222.776l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C312.1,223.607,311.759,223.017,311.342,222.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M294.24,212.902l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,213.734,294.657,213.143,294.24,212.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M301.081,216.852l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,217.683,301.498,217.092,301.081,216.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M304.501,218.826l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,219.658,304.918,219.067,304.501,218.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M311.342,222.776l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C312.1,223.607,311.759,223.017,311.342,222.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M314.762,224.751l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C315.52,225.582,315.18,224.992,314.762,224.751z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M339.601,241.014c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,242.246,339.599,241.731,339.601,241.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M339.601,241.014c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,242.246,339.599,241.731,339.601,241.014z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M336.854,243.718l0.015-0.008c-0.005,0.003-0.01,0.005-0.015,0.007L336.854,243.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M337.615,242.135c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,243.421,337.613,242.889,337.615,242.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M337.615,242.135c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,243.421,337.613,242.889,337.615,242.135z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M330.048,235.266c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.754-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,236.498,330.046,235.983,330.048,235.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M330.048,235.266c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.754-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,236.498,330.046,235.983,330.048,235.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M327.3,237.97l0.015-0.008c-0.005,0.003-0.01,0.005-0.015,0.007L327.3,237.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M328.061,236.386c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.194 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,237.673,328.059,237.141,328.061,236.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M328.061,236.386c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.193c0.648,0.374,1.237,0.419,1.674,0.194 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,237.673,328.059,237.141,328.061,236.386z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "401.51,196.182 401.51,183.685 345.747,163.988 289.984,183.685 289.984,196.394  346.112,228.799 401.875,196.393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "401.51,196.182 401.51,183.685 345.747,163.988 289.984,183.685 289.984,196.394  346.112,228.799 401.875,196.393  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "408.434,166.733 345.726,130.528 283.425,166.734 346.133,202.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "408.434,166.733 345.726,130.528 283.425,166.734 346.133,202.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "346.133,202.939 346.071,224.773 408.373,188.568 408.434,166.733  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "346.133,202.939 346.071,224.773 408.373,188.568 408.434,166.733  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "283.425,166.734 283.363,188.568 346.071,224.773 346.133,202.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.694,175.128 287.665,185.35 317.022,202.299 317.051,192.077  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M290.82,180.449l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C291.578,181.28,291.237,180.69,290.82,180.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M294.24,182.423l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,183.255,294.657,182.664,294.24,182.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M297.66,184.398l-0.855-0.494c-0.424-0.245-0.761-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C298.419,185.23,298.078,184.639,297.66,184.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M301.081,186.373l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,187.204,301.498,186.614,301.081,186.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.501,188.348l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,189.179,304.918,188.589,304.501,188.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M307.922,190.322l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C308.68,191.154,308.339,190.563,307.922,190.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.342,192.297l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.046,0.762-0.434l0.006-2.248 C312.1,193.128,311.759,192.538,311.342,192.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M294.24,182.423l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,183.255,294.657,182.664,294.24,182.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M301.081,186.373l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,187.204,301.498,186.614,301.081,186.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M304.501,188.348l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,189.179,304.918,188.589,304.501,188.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M311.342,192.297l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.046,0.762-0.434l0.006-2.248 C312.1,193.128,311.759,192.538,311.342,192.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M314.762,194.272l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C315.52,195.103,315.18,194.513,314.762,194.272z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M339.601,210.535c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,211.767,339.599,211.253,339.601,210.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M339.601,210.535c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,211.767,339.599,211.253,339.601,210.535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M336.854,213.24l0.015-0.008c-0.005,0.003-0.01,0.005-0.015,0.007L336.854,213.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M337.615,211.656c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,212.943,337.613,212.41,337.615,211.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M337.615,211.656c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,212.943,337.613,212.41,337.615,211.656z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M330.048,204.787c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,206.019,330.046,205.504,330.048,204.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M330.048,204.787c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,206.019,330.046,205.504,330.048,204.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M327.3,207.491l0.015-0.008c-0.005,0.003-0.01,0.005-0.015,0.007L327.3,207.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M328.061,205.908c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,207.195,328.059,206.662,328.061,205.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M328.061,205.908c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,207.195,328.059,206.662,328.061,205.908z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "401.51,165.704 401.51,153.206 345.747,133.509 289.984,153.206 289.984,165.915  346.112,198.32 401.875,165.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4
    },
    points: "401.51,165.704 401.51,153.206 345.747,133.509 289.984,153.206 289.984,165.915  346.112,198.32 401.875,165.914  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "408.434,136.255 345.726,100.049 283.425,136.255 346.133,172.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1
    },
    points: "408.434,136.255 345.726,100.049 283.425,136.255 346.133,172.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "346.133,172.46 346.071,194.295 408.373,158.089 408.434,136.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "346.133,172.46 346.071,194.295 408.373,158.089 408.434,136.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "283.425,136.255 283.363,158.09 346.071,194.295 346.133,172.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "287.694,144.65 287.665,154.871 317.022,171.82 317.051,161.599  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M290.82,149.97l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C291.578,150.801,291.237,150.211,290.82,149.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M294.24,151.945l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,152.776,294.657,152.186,294.24,151.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M297.66,153.919l-0.855-0.494c-0.424-0.245-0.761-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C298.419,154.751,298.078,154.16,297.66,153.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M301.081,155.894l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,156.726,301.498,156.135,301.081,155.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.501,157.869l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,158.7,304.918,158.11,304.501,157.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M307.922,159.844l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C308.68,160.675,308.339,160.085,307.922,159.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.342,161.818l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.046,0.762-0.434l0.006-2.248 C312.1,162.65,311.759,162.059,311.342,161.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M294.24,151.945l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C294.998,152.776,294.657,152.186,294.24,151.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M301.081,155.894l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C301.839,156.726,301.498,156.135,301.081,155.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M304.501,157.869l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.007,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C305.259,158.7,304.918,158.11,304.501,157.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M311.342,161.818l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.479,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.046,0.762-0.434l0.006-2.248 C312.1,162.65,311.759,162.059,311.342,161.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M314.762,163.793l-0.855-0.494c-0.424-0.245-0.76-0.045-0.762,0.434l-0.006,2.248 c-0.001,0.48,0.333,1.066,0.757,1.311l0.855,0.494c0.417,0.241,0.76,0.045,0.762-0.434l0.006-2.248 C315.52,164.624,315.18,164.034,314.762,163.793z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M339.601,180.057c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.38-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,181.288,339.599,180.774,339.601,180.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M339.601,180.057c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.38-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.009-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.156-0.088l0.015-0.009l-0.001-0.001C339.359,181.288,339.599,180.774,339.601,180.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M336.854,182.761l0.015-0.008C336.863,182.755,336.858,182.757,336.854,182.761L336.854,182.761 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M337.615,181.177c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,182.464,337.613,181.932,337.615,181.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M337.615,181.177c0.004-1.543-1.08-3.42-2.42-4.194c-0.66-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C337.348,182.464,337.613,181.932,337.615,181.177z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M330.048,174.308c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,175.54,330.046,175.025,330.048,174.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M330.048,174.308c0.004-1.543-1.079-3.42-2.42-4.194c-0.657-0.379-1.253-0.422-1.691-0.188 l-0.001-0.001l-0.016,0.009c-0.008,0.004-0.015,0.008-0.023,0.013l-1.952,1.101l0.001,0.001 c0.439-0.237,1.037-0.195,1.696,0.186c1.34,0.774,2.424,2.651,2.42,4.194c-0.002,0.755-0.266,1.287-0.692,1.544l1.878-1.064 c0.054-0.025,0.106-0.055,0.155-0.088l0.015-0.009l-0.001-0.001C329.806,175.54,330.046,175.025,330.048,174.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#787878"
    },
    d: "M327.3,177.013l0.015-0.008c-0.005,0.003-0.01,0.005-0.015,0.007L327.3,177.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M328.061,175.429c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,176.716,328.059,176.183,328.061,175.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M328.061,175.429c0.004-1.543-1.079-3.42-2.42-4.194c-0.659-0.381-1.257-0.423-1.696-0.186 c-0.455,0.245-0.739,0.79-0.741,1.575c-0.004,1.54,1.079,3.417,2.422,4.192c0.648,0.374,1.237,0.419,1.674,0.195 c0.005-0.003,0.01-0.005,0.015-0.007c0.018-0.01,0.037-0.02,0.055-0.031C327.795,176.716,328.059,176.183,328.061,175.429z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M369.829,276.541h7.16c0,0,8.32,54.63,8.893,65.102c-0.001,0.27-0.181,0.54-0.538,0.747 c-0.714,0.412-1.868,0.412-2.578,0c-0.313-0.182-0.463-0.416-0.499-0.654l-0.031,0.001 C381.24,335.488,369.829,276.541,369.829,276.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M376.99,276.541c0,0,0.358,2.349,0.925,6.132c-1.141,2.46-3.626,5.139-5.898,5.19 c-0.887-4.594-2.187-11.322-2.187-11.322H376.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M377.856,322.355h-7.16c0,0-8.32,54.63-8.893,65.102c0.002,0.27,0.181,0.54,0.538,0.746 c0.714,0.412,1.868,0.412,2.578,0c0.313-0.182,0.463-0.416,0.499-0.653l0.031,0.001 C366.445,381.302,377.856,322.355,377.856,322.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M370.696,322.355c0,0-0.358,2.349-0.925,6.132c2.105,0.857,4.362,1.329,6.633,1.38 c0.887-4.594,1.452-7.512,1.452-7.512H370.696z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M409.101,298.69h7.16c0,0,8.32,54.63,8.893,65.102c-0.001,0.27-0.181,0.54-0.538,0.746 c-0.714,0.412-1.868,0.412-2.578,0c-0.313-0.182-0.463-0.416-0.499-0.653l-0.031,0.001 C420.512,357.637,409.101,298.69,409.101,298.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M416.262,298.69c0,0,0.358,2.349,0.925,6.132c-1.141,2.46-3.626,5.139-5.898,5.19 c-0.887-4.594-2.187-11.322-2.187-11.322H416.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M335.482,297.94h-7.16c0,0-8.32,54.63-8.893,65.102c0.001,0.27,0.181,0.54,0.538,0.746 c0.714,0.412,1.868,0.412,2.578,0c0.313-0.182,0.463-0.416,0.499-0.653l0.031,0.001 C324.071,356.886,335.482,297.94,335.482,297.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M328.322,297.94c0,0-0.358,2.349-0.925,6.132c1.219,1.445,3.908,3.68,6.18,3.732 c0.887-4.594,1.906-9.864,1.906-9.864H328.322z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "413.756,250.162 410.618,289.986 414.443,292.862 417.876,251.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "373.381,227.376 370.243,267.199 374.068,270.076 377.501,229.054  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M363.732,262.034c0,0-23.934,6.733-42.374,24.465v7.26c3.4,4.077,29.296,24.249,56.499,32.619 c18.179-8.37,36.17-22.431,39.272-26.256v-7.259C410.291,279.49,363.732,262.034,363.732,262.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M321.358,286.498v7.26c3.4,4.077,29.296,24.249,56.499,32.619v-7.259 C350.653,310.748,324.758,290.576,321.358,286.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M377.856,319.118v7.259c18.179-8.37,36.17-22.431,39.272-26.256v-7.259 C414.026,296.687,396.035,310.748,377.856,319.118z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M426.707,241.988c-0.006-0.554-0.143-1.114-0.467-1.622c-15.948-25-49.01-32.717-56.336-30.825 l-3.426,3.462v17.924c25.503,3.246,47.376,19.87,56.204,32.696l1.176-0.463c1.725-0.68,2.859-2.345,2.859-4.2v-16.982 L426.707,241.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M426.707,241.988c0.015,1.286-0.753,2.536-2.072,3.01l-1.952,0.701v17.925l1.176-0.463 c1.725-0.68,2.859-2.345,2.859-4.2v-16.982L426.707,241.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M422.682,245.699l1.952-0.701c1.319-0.474,2.086-1.723,2.072-3.01 c-0.006-0.554-0.143-1.114-0.467-1.622c-15.948-25-49.01-32.717-56.336-30.825l-3.426,3.462 C373.835,211.646,410.167,218.915,422.682,245.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M366.478,213.003v17.924c25.503,3.246,47.376,19.87,56.204,32.696v-17.925 C410.167,218.915,373.835,211.646,366.478,213.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M318.738,405.483l0.99,5.937c4.714-2.245,6.229-4.77,6.229-4.77 c0.121-4.558,0.068-9.248,0.029-11.532c-1.251,2.774-3.995,4.645-5.702,7.201C319.624,403.305,319.137,404.373,318.738,405.483 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M317.223,410.776l2.504,0.644l-0.99-5.937C318.122,407.193,317.714,409.003,317.223,410.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M318.738,405.483l0.99,5.937c4.714-2.245,6.229-4.77,6.229-4.77 c0.121-4.558,0.068-9.248,0.029-11.532c-1.251,2.774-3.995,4.645-5.702,7.201C319.624,403.305,319.137,404.373,318.738,405.483 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M317.223,410.776l2.504,0.644l-0.99-5.937C318.122,407.193,317.714,409.003,317.223,410.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M326.212,388.539c-0.457-1.582-1.178-3.069-1.948-4.529c0.035,2.37-0.909,4.786-2.182,6.839 c-1.696,2.735-3.961,5.089-5.589,7.865c-1.982,3.379-3.009,7.355-5.614,10.281c-2.534,2.847-6.471,4.38-10.263,3.996 c-1.405-0.142-2.875-0.59-3.762-1.688c-0.401-0.496-0.61-1.151-0.622-1.791c-1.286,1.371-2.689,2.626-4.234,3.706 c-1.712,1.197-3.766,2.456-4.047,4.526c-0.233,1.712,0.949,3.373,2.459,4.211c1.511,0.839,3.29,1.019,5.015,1.12 c3.703,0.215,7.478,0.127,11.03-0.943c3.551-1.07,6.887-3.215,8.803-6.39c0.924-1.53,1.486-3.229,1.967-4.965 c0.491-1.773,0.899-3.584,1.514-5.293c0.4-1.111,0.886-2.178,1.545-3.164c1.707-2.556,4.451-4.426,5.702-7.201 c0.067-0.149,0.148-0.289,0.206-0.443C326.924,392.728,326.79,390.538,326.212,388.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M300.615,412.99c3.792,0.384,7.729-1.149,10.263-3.996c2.604-2.926,3.631-6.902,5.614-10.281 c1.629-2.776,3.893-5.13,5.589-7.865c1.274-2.053,2.218-4.469,2.182-6.839c0.452-1.767,1.361-3.871,1.154-4.253 c-4.878-0.429-8.13-1.648-13.593-2.416c-1.654,5.136-7.16,18.719-9.623,23.52c-1.602,3.123-3.575,6.097-5.97,8.651 c0.011,0.64,0.22,1.294,0.622,1.791C297.74,412.4,299.21,412.848,300.615,412.99z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M332.708,352.276c-0.593,9.45-3.004,16.298-4.855,29.181c0,0-11.314,3.377-18.363-1.551 l-0.293-19.844L332.708,352.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M283.461,391.845l0.99,5.937c4.713-2.245,6.229-4.77,6.229-4.77 c0.121-4.558,0.068-9.248,0.029-11.532c-1.251,2.774-3.995,4.645-5.702,7.201C284.348,389.667,283.861,390.735,283.461,391.845 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M281.947,397.138l2.504,0.644l-0.99-5.937C282.845,393.555,282.438,395.365,281.947,397.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M283.461,391.845l0.99,5.937c4.713-2.245,6.229-4.77,6.229-4.77 c0.121-4.558,0.068-9.248,0.029-11.532c-1.251,2.774-3.995,4.645-5.702,7.201C284.348,389.667,283.861,390.735,283.461,391.845 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M281.947,397.138l2.504,0.644l-0.99-5.937C282.845,393.555,282.438,395.365,281.947,397.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M290.935,374.901c-0.457-1.582-1.178-3.069-1.948-4.529c0.036,2.37-0.909,4.786-2.182,6.839 c-1.696,2.735-3.96,5.089-5.589,7.865c-1.982,3.378-3.01,7.354-5.614,10.281c-2.534,2.847-6.471,4.38-10.263,3.996 c-1.404-0.142-2.874-0.59-3.762-1.688c-0.401-0.496-0.61-1.151-0.622-1.791c-1.286,1.371-2.689,2.626-4.234,3.706 c-1.712,1.197-3.766,2.456-4.047,4.526c-0.233,1.712,0.948,3.373,2.459,4.212c1.511,0.839,3.29,1.02,5.015,1.12 c3.703,0.215,7.478,0.128,11.03-0.943c3.551-1.07,6.886-3.215,8.803-6.39c0.924-1.53,1.486-3.23,1.967-4.965 c0.491-1.773,0.899-3.584,1.515-5.293c0.4-1.11,0.886-2.178,1.545-3.164c1.707-2.556,4.451-4.426,5.702-7.201 c0.067-0.149,0.149-0.289,0.206-0.443C291.647,379.089,291.513,376.9,290.935,374.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M265.338,399.352c3.792,0.384,7.729-1.149,10.263-3.996c2.604-2.926,3.632-6.902,5.614-10.281 c1.629-2.776,3.893-5.13,5.589-7.865c1.274-2.053,2.218-4.469,2.182-6.839c0.452-1.767,1.361-3.871,1.154-4.253 c-4.878-0.429-8.13-1.648-13.593-2.416c-1.654,5.136-7.16,18.719-9.623,23.52c-1.602,3.123-3.575,6.098-5.97,8.651 c0.011,0.64,0.22,1.294,0.622,1.791C262.464,398.762,263.934,399.21,265.338,399.352z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M301.033,341.209c-2.184,9.213-5.72,15.554-9.726,27.938c0,0-11.723,1.413-17.835-4.638 l5.26-32.354L301.033,341.209z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M372.788,315.669c6.766-2.914,37.389-18.158,17.117-47.757l-50.249-7.213 c-1.642,15.768-16.136,26.098-16.136,26.098L372.788,315.669z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M362.721,277.067c9.665-0.538,19.146-3.764,27.184-9.154c-1.992-3.609-4.543-7.311-7.762-11.152 l-44.862,4.035c-0.439,3.715-0.769,7.392-1.003,11.017C344.471,275.729,353.653,277.572,362.721,277.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M334.586,198.391c-0.193-1.178-0.163-2.392,0.096-3.552c0.229-1.021,3.066-6.995,2.687-7.38 c-2.383-2.418-3.903-5.67-4.227-9.05c-0.324-3.379,0.549-6.862,2.43-9.688c-2.04-0.738-3.373-3.02-3.186-5.182 c0.187-2.162,1.952-4.088,4.089-4.464c1.814-0.32,3.63,0.379,5.43,0.769c3.059,0.664,6.243,0.441,9.341-0.007 c3.098-0.448,6.17-1.119,9.292-1.346c3.123-0.227,6.351,0.012,9.201,1.308c2.85,1.296,5.276,3.773,5.949,6.831 c4.63-0.908,9.992,2.869,10.856,7.508c0.838,4.5-1.813,9.017-1.401,13.576c0.279,3.085,1.947,5.887,3.965,8.237 c2.018,2.349,4.408,4.351,6.515,6.621c5.759,6.204,9.279,14.444,9.783,22.894c0.283,4.762-0.434,9.753-3.094,13.713 c-5.226,7.779-19.235,9.728-27.84,9.401c-8.773-0.333-17.432-3.264-24.604-8.327c-4.963-3.504-9.504-8.711-9.333-14.785 c0.08-2.856,1.201-5.562,1.961-8.316c0.76-2.754,1.131-5.832-0.197-8.362c-1.384-2.636-4.3-4.1-6.08-6.487 C335.365,201.158,334.816,199.801,334.586,198.391z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M346.864,221.423c1.303,1.074,3.106,1.277,4.795,1.276c4.605-0.003,9.205-1.21,13.218-3.471 c3.182-1.792,5.979-4.251,8.197-7.152l-4.759-0.412v-15.306l-16.538,6.383v8.84h-4.233c-0.852,1.102-1.594,2.274-2.029,3.59 C344.802,217.323,345.115,219.981,346.864,221.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M367.154,196.805c-2.688,6.06-8.039,11.259-15.379,12.119v-6.183L367.154,196.805z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M365.369,184.577c-0.167,0.966-0.339,2.908-0.181,3.875c0.158,0.967,0.573,1.914,1.284,2.589 c0.711,0.675,1.651,0.97,2.61,0.77c-0.509-2.525,1.25-5.294,3.753-5.906c2.503-0.612,5.34,1.031,6.055,3.507 c0.513,1.776-0.003,3.741-1.057,5.26c-1.054,1.519-2.595,2.639-4.221,3.518c-1.924,0.703-4.081-0.222-5.097-2 c-4.915,6.231-13.486,10.906-21.515,10.235c-2.181-0.182-4.377-0.813-6.107-2.153c-3.036-2.351-3.261-5.897-3.646-9.398 c-0.487-4.433-0.61-8.937,0.103-13.353c0.984-6.103,3.701-12.101,8.438-16.071C348.54,178.718,360.711,183.599,365.369,184.577z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F28F8F"
    },
    points: "348.647,183.067 343.15,189.844 348.263,191.602  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M352.956,194.903c-1.427,0.452-2.853,0.905-4.28,1.357c0.449,0.993,1.855,1.603,2.903,1.305 C352.627,197.268,353.096,195.984,352.956,194.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M352.956,194.903c-1.427,0.452-2.853,0.905-4.28,1.357c0.449,0.993,1.855,1.603,2.903,1.305 C352.627,197.268,353.096,195.984,352.956,194.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M350.173,197.493c0.468,0.155,0.967,0.197,1.406,0.072c0.823-0.234,1.283-1.076,1.377-1.949 c-0.568-0.081-1.163,0.021-1.655,0.317C350.735,196.273,350.333,196.853,350.173,197.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.219,184.478c-0.038,0.842-0.752,1.494-1.593,1.456c-0.842-0.038-1.494-0.751-1.456-1.594 c0.038-0.842,0.751-1.494,1.593-1.456C355.605,182.922,356.257,183.636,356.219,184.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.44,183.407c-0.038,0.842-0.751,1.494-1.593,1.456c-0.842-0.038-1.494-0.751-1.456-1.593 c0.038-0.842,0.751-1.494,1.594-1.456C342.826,181.852,343.478,182.565,343.44,183.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.229,177.272c-1.162,0.728-2.323,1.457-3.485,2.185c-0.298-0.817,0.071-1.843,0.768-2.363 C340.21,176.575,341.532,176.753,342.229,177.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.294,177.677c1.091,0.83,2.183,1.66,3.275,2.49c0.37-0.787,0.095-1.842-0.553-2.423 C357.369,177.164,356.036,177.223,355.294,177.677z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M391.791,268.619c-8.539-12.841-9.05-21.833-4.792-29.405c1.297-2.307,1.076-11.58,0.714-18.376 c-0.23-4.318-3.602-7.805-7.91-8.179l-6.73-0.583c-2.217,2.901-5.015,5.36-8.197,7.152c-4.013,2.26-8.612,3.468-13.218,3.471 c-2.503,0.001-5.258-0.445-6.26-3.512c-0.275-0.843-0.339-1.752-0.212-2.63c0.274-1.903,1.218-3.501,2.357-4.975h-4.116 c-4.938,4.392-14.272,22.162-14.854,31.723c-0.292,4.798,3.413,7.151,5.966,8.642c0,0,1.741,7.084-0.85,20.224 C346.3,281.065,375.666,281.996,391.791,268.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M370.861,243.225c-2.292,3.292-5.73,5.769-9.578,6.9c-3.848,1.131-8.08,0.908-11.788-0.62 c3.14,3.07,7.944,4.492,12.197,3.398C365.945,251.809,369.591,247.429,370.861,243.225z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M368.313,210.193v1.47l-8.135,34.029c0,0,0.857,17.944,11.695,38.264 c12.312,2.324,22.253-4.418,24.868-7.767c-7.462-10.16-12.404-30.029-12.404-30.029l-1.267-33.432l-13.771-0.953 L368.313,210.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M368.313,211.664v-1.47l3.886,6.935c0.453,0.808,0.342,1.815-0.276,2.506l-4.385,4.897 l2.251,2.135c0.741,0.703,0.891,1.83,0.358,2.702l-9.969,16.324L368.313,211.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M368.313,211.664v-1.47l3.886,6.935c0.453,0.808,0.342,1.815-0.276,2.506 l-4.385,4.897l2.251,2.135c0.741,0.703,0.891,1.83,0.358,2.702l-9.969,16.324L368.313,211.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M374.178,219.308l-9.382,40.859l-1.943,0.706l0.849-5.536 C365.603,242.921,369.126,230.808,374.178,219.308L374.178,219.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M384.39,266.8l1.881-13.889c-1.248-3.988-1.935-6.75-1.935-6.75l-0.293-7.721l-16.932,35.288 c0.621,1.543,1.293,3.116,2.03,4.717l5.854-1.348C379.964,275.953,383.705,271.852,384.39,266.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M335.721,274.239c-0.065-11.459,0.044-24.757,1.126-32.142 c3.689-16.629,8.516-22.844,12.613-30.515h2.315v-2.658l-3.677,2.658h-4.672c-16.935,19.948-16.858,30.933-16.965,34.111 c-0.106,3.178,0.505,23.492,0.505,23.492L335.721,274.239z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M342.02,215.975c-0.612,0.442-0.949,1.171-0.891,1.923l0.309,4.014l-3.852,1.501 c-0.879,0.343-1.436,1.216-1.376,2.158l0.967,15.121c3.646-15.564,8.306-21.663,12.283-29.11h2.315v-2.658L342.02,215.975z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.02,215.975c-0.612,0.442-0.949,1.171-0.891,1.923l0.309,4.014l-3.852,1.501 c-0.879,0.343-1.436,1.216-1.376,2.158l0.967,15.121c3.646-15.564,8.306-21.663,12.283-29.11h2.315v-2.658L342.02,215.975z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "177.33,285.38 177.33,382.993 180.782,380.996 180.782,283.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "177.33,285.38 177.33,382.993 173.878,380.996 173.878,283.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "180.782,311.409 261.568,264.767 261.568,261.059 180.782,307.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "180.782,303.783 258.116,259.066 261.568,261.059 180.782,307.701  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "402.649,318.259 402.649,415.872 406.1,413.875 406.1,316.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "402.649,318.259 402.649,415.872 399.197,413.875 399.197,316.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "318.412,366.911 318.412,464.524 321.863,462.527 321.863,364.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "318.412,366.911 318.412,464.524 314.96,462.527 314.96,364.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "321.863,392.94 402.649,346.299 402.649,342.59 321.863,389.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "321.863,385.315 399.197,340.597 402.649,342.59 321.863,389.232  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "402.649,318.259 402.649,415.872 406.1,413.875 406.1,316.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "402.649,318.259 402.649,415.872 399.197,413.875 399.197,316.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "318.412,366.911 318.412,464.524 321.863,462.527 321.863,364.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "318.412,366.911 318.412,464.524 314.96,462.527 314.96,364.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "321.863,392.94 402.649,346.299 402.649,342.59 321.863,389.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "321.863,385.315 399.197,340.597 402.649,342.59 321.863,389.232  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "177.33,285.38 177.33,382.993 180.782,380.996 180.782,283.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "177.33,285.38 177.33,382.993 173.878,380.996 173.878,283.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "180.782,311.409 261.568,264.767 261.568,261.059 180.782,307.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "180.782,303.783 258.116,259.066 261.568,261.059 180.782,307.701  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "318.412,357.486 173.873,274.239 261.562,223.59 406.1,306.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "318.412,366.912 173.873,283.384 173.873,274.239 318.412,357.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "318.412,357.475 406.1,306.826 406.1,316.263 318.412,366.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    points: "318.412,357.486 173.873,274.239 261.562,223.59 406.1,306.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "318.412,357.475 406.1,306.826 406.1,316.263 318.412,366.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "318.412,366.912 173.873,283.384 173.873,274.239 318.412,357.486  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.05
    },
    d: "M325.7,332.004c-4.18-2.413-10.935-2.413-15.088,0c-4.153,2.413-4.131,6.326,0.049,8.739 c4.18,2.413,10.935,2.413,15.088,0C329.902,338.33,329.88,334.418,325.7,332.004z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M329.324,316.819l-11.467,0.334l-11.467-0.334c-0.494,7.744,1.018,15.636,3.103,19.491 l0.008-0.001c0.373,0.846,1.124,1.648,2.27,2.31c3.384,1.954,8.852,1.954,12.214,0c1.165-0.677,1.915-1.502,2.268-2.37 C328.321,332.373,329.816,324.525,329.324,316.819z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M325.939,312.122c4.493,2.594,4.517,6.799,0.053,9.394c-4.464,2.594-11.724,2.594-16.217,0 c-4.493-2.594-4.516-6.799-0.053-9.394C314.186,309.528,321.446,309.528,325.939,312.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M324.162,313.154c3.505,2.024,3.524,5.305,0.041,7.329c-3.483,2.024-9.147,2.024-12.652,0 c-3.505-2.024-3.524-5.305-0.041-7.328C314.993,311.131,320.657,311.131,324.162,313.154z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.162,313.154c3.505,2.024,3.524,5.305,0.041,7.329c-3.483,2.024-9.147,2.024-12.652,0 c-3.505-2.024-3.524-5.305-0.041-7.328C314.993,311.131,320.657,311.131,324.162,313.154z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M316.9,317.143c1.925,1.578,4.504,2.163,6.726,1.53c2.216-0.631,4.022-2.459,4.714-4.766 c-1.402-0.609-2.505-1.507-3.682-2.555c1.639-0.432,3.541-0.365,5.212,0.184c0.903-1.378,1.135-3.362,0.393-4.97 c-1.977-0.868-4.249-1.029-6.217-0.43c1.742-1.509,3.957-2.21,6.286-1.981c0.229-5.635-1.51-9.657-1.51-9.657 c-4.276,0.223-8.421,2.065-9.818,3.391c-0.238,1.71,0.473,4.542,0.473,4.542c-1.953-1.083-1.987-2.937-1.987-2.937 c-2.676,0.669-3.819,2.005-4.237,3.023c0.197,1.675,1.743,4.476,2.533,5.131c-2.513-0.759-3.532-3.558-3.532-3.558 C309.785,309.944,310.256,316.573,316.9,317.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M316.9,317.143c1.925,1.578,4.504,2.163,6.726,1.53c2.216-0.631,4.022-2.459,4.714-4.766 c-1.402-0.609-2.505-1.507-3.682-2.555c1.639-0.432,3.541-0.365,5.212,0.184c0.903-1.378,1.135-3.362,0.393-4.97 c-1.977-0.868-4.249-1.029-6.217-0.43c1.742-1.509,3.957-2.21,6.286-1.981c0.229-5.635-1.51-9.657-1.51-9.657 c-4.276,0.223-8.421,2.065-9.818,3.391c-0.238,1.71,0.473,4.542,0.473,4.542c-1.953-1.083-1.987-2.937-1.987-2.937 c-2.676,0.669-3.819,2.005-4.237,3.023c0.197,1.675,1.743,4.476,2.533,5.131c-2.513-0.759-3.532-3.558-3.532-3.558 C309.785,309.944,310.256,316.573,316.9,317.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M316.9,317.143c1.925,1.578,4.504,2.163,6.726,1.53 c2.216-0.631,4.022-2.459,4.714-4.766c-1.402-0.609-2.505-1.507-3.682-2.555c1.639-0.432,3.541-0.365,5.212,0.184 c0.903-1.378,1.135-3.362,0.393-4.97c-1.977-0.868-4.249-1.029-6.217-0.43c1.742-1.509,3.957-2.21,6.286-1.981 c0.229-5.635-1.51-9.657-1.51-9.657c-4.276,0.223-8.421,2.065-9.818,3.391c-0.238,1.71,0.473,4.542,0.473,4.542 c-1.953-1.083-1.987-2.937-1.987-2.937c-2.676,0.669-3.819,2.005-4.237,3.023c0.197,1.675,1.743,4.476,2.533,5.131 c-2.513-0.759-3.532-3.558-3.532-3.558C309.785,309.944,310.256,316.573,316.9,317.143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M316.751,317.777c-0.006,0-0.013,0-0.019-0.001c-0.136-0.01-0.238-0.129-0.228-0.265 c0.408-5.399,3.497-14.312,10.862-21.664c0.096-0.096,0.253-0.096,0.349,0c0.097,0.096,0.097,0.253,0,0.349 c-7.269,7.256-10.317,16.037-10.718,21.351C316.987,317.678,316.878,317.777,316.751,317.777z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M318.771,320.032c-1.707,1.393-4.093,1.911-6.224,1.35c-2.131-0.56-3.954-2.185-4.755-4.237 c1.29-0.538,2.278-1.334,3.324-2.26c-1.577-0.39-3.375-0.337-4.926,0.146c-0.946-1.231-1.293-3.002-0.69-4.433 c1.824-0.763,3.968-0.893,5.868-0.347c-1.744-1.354-3.888-1.994-6.088-1.806c-0.578-5.04,0.822-8.621,0.822-8.621 c4.076,0.247,8.11,1.935,9.509,3.129c0.329,1.523-0.165,4.034-0.165,4.034c1.77-0.947,1.688-2.593,1.688-2.593 c2.552,0.617,3.705,1.811,4.158,2.717c-0.082,1.482-1.358,3.952-2.058,4.528c2.305-0.659,3.088-3.129,3.088-3.129 C324.977,313.695,324.936,319.535,318.771,320.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M318.771,320.032c-1.707,1.393-4.093,1.911-6.224,1.35 c-2.131-0.56-3.954-2.185-4.755-4.237c1.29-0.538,2.278-1.334,3.324-2.26c-1.577-0.39-3.375-0.337-4.926,0.146 c-0.946-1.231-1.293-3.002-0.69-4.433c1.824-0.763,3.968-0.893,5.868-0.347c-1.744-1.354-3.888-1.994-6.088-1.806 c-0.578-5.04,0.822-8.621,0.822-8.621c4.076,0.247,8.11,1.935,9.509,3.129c0.329,1.523-0.165,4.034-0.165,4.034 c1.77-0.947,1.688-2.593,1.688-2.593c2.552,0.617,3.705,1.811,4.158,2.717c-0.082,1.482-1.358,3.952-2.058,4.528 c2.305-0.659,3.088-3.129,3.088-3.129C324.977,313.695,324.936,319.535,318.771,320.032z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M318.934,320.621c-0.12,0-0.225-0.088-0.243-0.211c-0.701-4.701-4.118-12.504-11.437-19.025 c-0.102-0.091-0.11-0.247-0.02-0.349c0.09-0.102,0.246-0.111,0.349-0.02c7.417,6.608,10.882,14.538,11.596,19.321 c0.02,0.135-0.073,0.261-0.207,0.281C318.959,320.62,318.947,320.621,318.934,320.621z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M247.219,270.746l34.074-19.801c1.926-1.119,5.054-1.119,6.993,0l56.217,32.457 c0.923,0.533,1.396,1.224,1.445,1.923l0.015,0.002v2.162l-0.031-0.004c-0.004,0.15,0.002,0.301-0.043,0.45 c-0.004,0.015-0.004,0.03-0.009,0.045c-0.053,0.163-0.137,0.322-0.24,0.478c-0.011,0.017-0.016,0.035-0.028,0.052 c-0.113,0.162-0.255,0.319-0.422,0.469c-0.01,0.009-0.016,0.019-0.026,0.028c-0.18,0.158-0.388,0.308-0.628,0.447l-34.074,19.802 c-0.298,0.173-0.631,0.31-0.977,0.43c-0.122,0.042-0.248,0.079-0.375,0.115c-0.164,0.046-0.326,0.089-0.496,0.123 c-0.199,0.041-0.401,0.078-0.606,0.104c-0.048,0.006-0.096,0.015-0.145,0.02c-0.276,0.029-0.555,0.044-0.834,0.046 c-0.044,0-0.089,0.001-0.133,0c-0.276-0.002-0.551-0.017-0.823-0.046c-0.041-0.004-0.082-0.009-0.123-0.014 c-0.27-0.032-0.536-0.078-0.795-0.137c-0.048-0.011-0.095-0.023-0.143-0.035c-0.236-0.058-0.464-0.129-0.685-0.209 c-0.041-0.015-0.083-0.026-0.123-0.042c-0.266-0.103-0.519-0.22-0.754-0.356l-56.217-32.457c-0.243-0.14-0.455-0.291-0.637-0.451 c-0.064-0.056-0.104-0.117-0.16-0.175c-0.105-0.107-0.217-0.213-0.296-0.325c-0.048-0.069-0.071-0.142-0.109-0.212 c-0.059-0.106-0.127-0.211-0.164-0.32c-0.026-0.077-0.024-0.155-0.04-0.233c-0.02-0.105-0.052-0.21-0.052-0.316v-1.993 C245.773,272.04,246.253,271.307,247.219,270.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M345.947,285.324c0.014,0.206,0.002,0.413-0.059,0.616c-0.004,0.015-0.004,0.03-0.009,0.045 c-0.053,0.163-0.137,0.322-0.24,0.478c-0.011,0.017-0.016,0.035-0.028,0.051c-0.112,0.162-0.255,0.318-0.421,0.469 c-0.01,0.009-0.016,0.019-0.026,0.027c-0.18,0.158-0.388,0.309-0.628,0.448l-34.074,19.801c-0.298,0.173-0.631,0.31-0.977,0.43 c-0.122,0.042-0.248,0.079-0.375,0.114c-0.164,0.046-0.326,0.089-0.496,0.123c-0.199,0.041-0.401,0.078-0.606,0.104 c-0.048,0.006-0.096,0.015-0.144,0.02c-0.276,0.029-0.555,0.043-0.835,0.046c-0.044,0-0.089,0.001-0.133,0 c-0.276-0.002-0.551-0.018-0.823-0.046c-0.041-0.004-0.082-0.009-0.123-0.014c-0.27-0.033-0.536-0.078-0.795-0.137 c-0.048-0.011-0.095-0.023-0.143-0.035c-0.236-0.058-0.464-0.129-0.685-0.209c-0.041-0.015-0.083-0.026-0.123-0.042 c-0.266-0.103-0.519-0.22-0.754-0.356l-56.217-32.457c-0.243-0.14-0.455-0.291-0.637-0.451c-0.064-0.056-0.104-0.117-0.16-0.174 c-0.105-0.107-0.217-0.213-0.296-0.325c-0.048-0.069-0.071-0.142-0.109-0.212c-0.059-0.106-0.127-0.211-0.164-0.32 c-0.026-0.077-0.024-0.155-0.04-0.233c-0.02-0.105-0.052-0.21-0.052-0.316v1.993c0,0.106,0.031,0.211,0.052,0.316 c0.015,0.077,0.014,0.156,0.04,0.233c0.037,0.109,0.105,0.214,0.164,0.32c0.039,0.071,0.061,0.143,0.109,0.212 c0.079,0.112,0.191,0.218,0.296,0.325c0.056,0.058,0.096,0.119,0.16,0.175c0.182,0.159,0.395,0.31,0.637,0.451l56.217,32.457 c0.235,0.135,0.488,0.253,0.754,0.356c0.04,0.016,0.083,0.027,0.123,0.042c0.221,0.08,0.449,0.151,0.685,0.209 c0.048,0.012,0.095,0.024,0.143,0.035c0.259,0.059,0.526,0.104,0.795,0.137c0.041,0.005,0.082,0.01,0.123,0.014 c0.272,0.028,0.547,0.044,0.823,0.046c0.044,0,0.089,0,0.133,0c0.28-0.002,0.559-0.016,0.835-0.046 c0.049-0.005,0.096-0.014,0.144-0.02c0.205-0.026,0.406-0.063,0.606-0.104c0.17-0.035,0.332-0.077,0.496-0.123 c0.127-0.036,0.253-0.072,0.375-0.115c0.346-0.12,0.679-0.257,0.977-0.43l34.074-19.802c0.24-0.139,0.449-0.289,0.628-0.447 c0.01-0.009,0.016-0.019,0.026-0.028c0.166-0.15,0.309-0.307,0.421-0.469c0.012-0.017,0.017-0.034,0.028-0.052 c0.102-0.156,0.186-0.315,0.24-0.478c0.005-0.015,0.005-0.03,0.009-0.045c0.045-0.148,0.039-0.299,0.043-0.45l0.031,0.004v-2.162 L345.947,285.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M250.546,272.771l54.614,31.531c0.057,0.033,0.117,0.062,0.215,0.103l0.118,0.04 c0.102,0.038,0.208,0.072,0.427,0.125c0.147,0.035,0.295,0.059,0.3,0.063l0.207,0.02c0.146,0.015,0.303,0.023,0.532,0.027h0.048 c0.168-0.002,0.337-0.01,0.559-0.037c0.117-0.015,0.23-0.037,0.357-0.063c0.085-0.017,0.442-0.118,0.442-0.118 c0.13-0.045,0.26-0.087,0.379-0.157l17.568-10.214l-56.414-32.57L250.546,272.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M307.022,304.682c-0.025,0-0.039-0.001-0.061-0.001h-0.02L307.022,304.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M302.503,264.097l-10.275,6.043c-0.686,0.404-0.682,1.398,0.007,1.796l15.363,8.87 c0.533,0.307,1.19,0.305,1.72-0.007l10.274-6.043c0.686-0.404,0.682-1.398-0.007-1.796l-15.363-8.87 C303.69,263.783,303.033,263.785,302.503,264.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M250.546,272.771l54.614,31.531c0.057,0.033,0.117,0.062,0.215,0.103l0.118,0.04 c0.102,0.038,0.208,0.072,0.427,0.125c0.147,0.035,0.295,0.059,0.3,0.063l0.207,0.02c0.146,0.015,0.303,0.023,0.532,0.027h0.048 c0.168-0.002,0.337-0.01,0.559-0.037c0.117-0.015,0.23-0.037,0.357-0.063c0.085-0.017,0.442-0.118,0.442-0.118 c0.13-0.045,0.26-0.087,0.379-0.157l17.568-10.214l-56.414-32.57L250.546,272.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M302.503,264.097l-10.275,6.043c-0.686,0.404-0.682,1.398,0.007,1.796l15.363,8.87 c0.533,0.307,1.19,0.305,1.72-0.007l10.274-6.043c0.686-0.404,0.682-1.398-0.007-1.796l-15.363-8.87 C303.69,263.783,303.033,263.785,302.503,264.097z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M327.845,272.937c-3.116,4.211-0.542,10.838,3.477,11.606 C338.096,280.705,333.264,273.569,327.845,272.937z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M313.452,274.572l-6.313,2.75c-0.626,0.273-1.008,0.914-0.948,1.595l0,0 c0.072,0.821,0.759,1.451,1.583,1.451h5.943L313.452,274.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M322.529,275.509l-5.615-2.609c-1.406-0.653-3.069-0.377-4.188,0.697l-3.995,3.833 c-0.537,0.515-0.872,1.206-0.944,1.946l-0.397,4.089c-0.071,0.727,0.402,1.397,1.11,1.574h0 c0.873,0.218,1.737-0.389,1.826-1.285l0.358-3.58l2.092-2.321l-1.155,1.785c-0.306,0.473-0.461,1.029-0.442,1.592l0.101,3.08 c0.032,0.979,0.607,1.86,1.491,2.282l4.868,2.326c0.835,0.399,1.819,0.328,2.589-0.186c0,0,1.546-1.055,2.122-1.631 c0.564-0.564,0.181-1.403,0.181-1.403l2.235-1.615l44.935-7.698l-10.831-14.068L322.529,275.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M322.529,285.699c-2.055,0.839-3.093,0.522-3.093,0.522c0.361-1.106,0.113-3.048,0.113-3.048 c0.926,1.332,0.903,2.303,0.903,2.303S321.219,285.967,322.529,285.699z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M383.069,212.729c-4.18-0.297-7.953,2.495-8.891,6.579l-9.382,40.859l-5.927,2.152l-31.022,10.619 c5.283,3.975,3.477,11.606,3.477,11.606l38.376-8.157c6.692-1.146,11.974-6.317,13.264-12.982l7.851-40.578 C391.783,217.819,388.156,213.091,383.069,212.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M364.795,260.167c4.142,0.037,7.394,4.282,7.8,5.863c0.813-8.354-4.038-8.678-7.46-7.342 L364.795,260.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M341.163,211.529c-6.788-0.157-13.388,2.24-18.493,6.717l-23.317,20.451 c-1.509,1.323-2.826,2.849-3.915,4.535l-12.162,18.829l12.192,8.091l13.019-18.788l19.122-13.329 c1.63-5.765,5.666-14.498,15.816-26.454L341.163,211.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M321.696,242.158l5.914-4.122c1.294-4.575,4.116-11.027,10.293-19.468 C330.576,224.845,324.914,233.059,321.696,242.158z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M238.04,231.053l-0.015-0.005l1.345-0.672l0.002,0.01c0.46-0.192,1.003-0.197,1.504,0.094 l56.606,32.911c1.778,1.034,2.996,2.813,3.315,4.845l5.819,37.007c0.127,0.809-0.319,1.481-0.95,1.79l0.024,0.004l-1.303,0.642 l0-0.006c-0.449,0.171-0.973,0.163-1.456-0.118l-56.606-32.911c-1.778-1.034-2.996-2.813-3.315-4.845l-5.82-37.007 C237.072,232.027,237.464,231.383,238.04,231.053z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.91,264.917c2.742,1.583,5.249,5.205,5.617,8.091c0.369,2.887-1.538,3.96-4.281,2.377 c-2.73-1.576-5.249-5.205-5.617-8.091C264.261,264.407,266.181,263.341,268.91,264.917z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M305.478,305.813l-5.819-37.007c-0.319-2.032-1.537-3.812-3.315-4.845l-56.606-32.911 c-0.575-0.334-1.204-0.28-1.698,0.004l-0.015-0.005l1.345-0.672l0.002,0.01c0.46-0.192,1.003-0.197,1.504,0.094l56.606,32.911 c1.778,1.034,2.996,2.813,3.315,4.845l5.819,37.007c0.127,0.809-0.319,1.481-0.95,1.79l0.024,0.004l-1.303,0.642l0-0.006 C305.095,307.404,305.615,306.681,305.478,305.813z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.5b15c9fa4385c1b9a82d3445d697cc8c.svg";
export { ForwardRef as ReactComponent };